import countryRows from "./profileCountriesData.json";

/** @type {Map<string, string>} */
const BY_ISO = new Map(countryRows.map(([iso, name]) => [iso, name]));

/** @type {Map<string, string>} */
const ISO_BY_NAME_LOWER = new Map(
  countryRows.map(([iso, name]) => [name.trim().toLowerCase(), iso])
);

/**
 * @param {string} [iso]
 * @returns {string}
 */
export function isoToFlagEmoji(iso) {
  const code = String(iso || "").toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return "";
  return String.fromCodePoint(...[...code].map((c) => 0x1f1e6 - 65 + c.charCodeAt(0)));
}

/**
 * @param {string} [iso]
 * @returns {string | null}
 */
export function countryNameForIso(iso) {
  const key = String(iso || "").toUpperCase();
  return BY_ISO.get(key) || null;
}

/**
 * Resolve form value from stored player fields (ISO preferred; legacy name match).
 * @param {{ countryIso?: string | null; country?: string | null }} player
 * @returns {string} ISO code or ""
 */
export function resolveProfileCountryIso(player) {
  const iso = String(player?.countryIso || "").toUpperCase();
  if (iso && BY_ISO.has(iso)) return iso;
  const legacy = String(player?.country || "").trim().toLowerCase();
  if (legacy && ISO_BY_NAME_LOWER.has(legacy)) return ISO_BY_NAME_LOWER.get(legacy);
  return "";
}

/**
 * @returns {Array<{ id: string; label: string; prefix: string }>}
 */
export function profileCountrySelectOptions() {
  return countryRows.map(([iso, name]) => ({
    id: iso,
    label: name,
    prefix: isoToFlagEmoji(iso),
  }));
}

/**
 * @param {string | null | undefined} iso
 * @returns {{ ok: true; empty: true } | { ok: true; empty: false; countryIso: string; country: string } | { ok: false; error: string }}
 */
export function validateProfileCountryIso(iso) {
  const raw = String(iso ?? "").trim().toUpperCase();
  if (!raw) return { ok: true, empty: true };
  const name = countryNameForIso(raw);
  if (!name) return { ok: false, error: "Choose a country from the list." };
  return { ok: true, empty: false, countryIso: raw, country: name };
}
